import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const { data } = response
  if (data.authorizationCode) {
    return data.authorizationCode
  } else {
    throw response
  }
}

export interface UserData {
  mobile: string
  name: string
}

const trustedUserAuth = (userData: UserData, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.userAuth),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      user: {
        mobile: {
          mobileNumber: userData.mobile,
          countryCode: '91',
        },
      },
      scope: 'REQUEST',
      authenticateList: [
        {
          mode: '5',
        },
      ],
      purpose: 2,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { trustedUserAuth }
